'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimestampControl = function () {
  function TimestampControl(element, args) {
    var _this = this;

    _classCallCheck(this, TimestampControl);

    var div = document.createElement('div');
    this.input = document.createElement('input');
    this.input.id = window.PRIM.getUUID();
    this.setValue(args.value);
    this.input.type = 'text';
    this.input.autocapitalize = 'off';
    this.input.autocorrect = 'off';
    this.input.spellcheck = 'false';
    this.input.pattern = '\d{4}(-\d{2}(-\d{2}( \d{2}(:\d{2}(:\d{2})?)?)?)?)?';
    this.input.disabled = args.readonly ? 'disabled' : '';
    this.input.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.input.id;

    var onclick = function onclick() {
      if (args.readonly) {
        return;
      }
      _this.setValue(new Date());
      _this.input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    var button = document.createElement('button');
    button.className = 'icon';
    button.innerHTML = '\uE138';
    button.onclick = onclick;

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.input);
    div.appendChild(button);

    element.appendChild(fragment);
  }

  _createClass(TimestampControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input.value ? new Date(this.input.value).toISOString() : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.input.value = value ? window.PRIM.getUtcTimestamp(new Date(value)).toISOString().substring(0, 19).replace('T', ' ') : '';
    }
  }]);

  return TimestampControl;
}();

exports.default = TimestampControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/TimestampControl.js
// module id = 68
// module chunks = 0